/* ============================================================
   Maison Atelier Premium — search-overlay.js
   Predictive search (Shopify) con stato empty elegante
   ============================================================ */
(function () {
  'use strict';
  var routes = (window.theme && window.theme.routes) || {};
  var strings = (window.theme && window.theme.strings) || {};
  var utils = (window.theme && window.theme.utils) || {};

  var overlay = document.querySelector('[data-search-overlay]');
  if (!overlay) return;
  var input = overlay.querySelector('[data-search-input]');
  var results = overlay.querySelector('[data-predictive]');
  if (!input || !results) return;
  var defaultHTML = results ? results.innerHTML : '';
  var status = overlay.querySelector('[data-search-tools-status]');

  // focus automatico all'apertura
  document.addEventListener('panel:open', function (e) {
    if (e.detail.panel !== overlay || !input) return;
    if (results && input.value.trim().length < 2) results.innerHTML = defaultHTML;
    setTimeout(function () { input.focus(); }, 80);
  });

  function money(amount) {
    var cents = Math.round(Number(amount) * 100);
    return utils.formatMoney ? utils.formatMoney(cents) : (cents / 100).toFixed(2);
  }

  function escapeHTML(value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, function (character) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[character];
    });
  }

  function render(data, term) {
    var response = data && data.resources && data.resources.results ? data.resources.results : {};
    var products = response.products || [];
    var queries = response.queries || [];
    var collections = response.collections || [];

    if (!products.length && !queries.length && !collections.length) {
      results.innerHTML = '<div class="search-empty"><p class="h3">' +
        escapeHTML(strings.noResults || 'Nessun risultato') + '</p></div>';
      return;
    }

    var html = '';
    if (queries.length || collections.length) {
      html += '<div class="predictive__group"><p class="predictive__heading">' + escapeHTML(strings.suggestions || 'Suggerimenti') + '</p><div class="predictive__links">';
      queries.slice(0, 4).forEach(function (q) {
        html += '<a href="' + escapeHTML(routes.search) + '?q=' + encodeURIComponent(q.text) + '&type=product">' + escapeHTML(q.text) + '</a>';
      });
      collections.slice(0, 3).forEach(function (c) {
        html += '<a href="' + escapeHTML(c.url) + '">' + escapeHTML(c.title) + '</a>';
      });
      html += '</div></div>';
    }

    if (products.length) {
      html += '<div class="predictive__group"><p class="predictive__heading">' + escapeHTML(strings.products || 'Prodotti') + '</p><div class="predictive__products">';
      products.slice(0, 6).forEach(function (p) {
        var img = p.featured_image && p.featured_image.url ? p.featured_image.url : '';
        if (img) {
          var imageURL = new URL(img, window.location.origin);
          imageURL.searchParams.set('width', '400');
          img = imageURL.href;
        }
        html += '<a class="card" href="' + escapeHTML(p.url) + '">' +
          '<span class="card__media" data-ratio="portrait">' +
          (img ? '<img class="card__image" src="' + escapeHTML(img) + '" alt="" loading="lazy" width="400" height="500">' : '') +
          '</span>' +
          '<span class="card__info"><span class="card__title">' + escapeHTML(p.title) + '</span>' +
          '<span class="price">' + money(p.price) + '</span></span></a>';
      });
      html += '</div></div>';
      html += '<div class="text-center" style="margin-top:var(--space-lg)"><a class="link-underline" href="' +
        escapeHTML(routes.search) + '?q=' + encodeURIComponent(term) + '&type=product">' + escapeHTML(strings.viewAll || 'Vedi tutti i risultati') + '</a></div>';
    }
    results.innerHTML = html;
  }

  var searchTimer;
  var controller;
  var requestId = 0;

  function search(term, id) {
    controller = new AbortController();
    results.setAttribute('aria-busy', 'true');
    fetch(routes.predictiveSearch + '.json?q=' + encodeURIComponent(term) + '&resources[type]=product,collection,query&resources[limit]=6', { signal: controller.signal })
      .then(function (response) { if (!response.ok) throw new Error('Search unavailable'); return response.json(); })
      .then(function (data) { if (id === requestId) render(data, term); })
      .catch(function (error) {
        if (error.name === 'AbortError' || id !== requestId) return;
        results.innerHTML = '<a class="link-underline" href="' + escapeHTML(routes.search) + '?q=' + encodeURIComponent(term) + '&type=product">' + escapeHTML(strings.viewAll || 'Vedi tutti i risultati') + '</a>';
      })
      .finally(function () { if (id === requestId) results.removeAttribute('aria-busy'); });
  }

  if (input) {
    input.addEventListener('input', function () {
      var term = input.value.trim();
      clearTimeout(searchTimer);
      if (controller) controller.abort();
      var id = ++requestId;
      if (term.length < 2) {
        results.innerHTML = defaultHTML;
        results.removeAttribute('aria-busy');
        return;
      }
      searchTimer = setTimeout(function () { search(term, id); }, 250);
    });
  }

  var visualInput = overlay.querySelector('[data-visual-search]');
  if (visualInput && status) {
    visualInput.addEventListener('change', function () {
      var file = visualInput.files && visualInput.files[0];
      if (!file) return;
      var guessed = file.name.replace(/\.[^.]+$/, '').replace(/[-_]+/g, ' ').trim();
      status.textContent = strings.visualSearchReady || 'Immagine pronta';
      if (file.type && file.type.indexOf('image/') === 0) {
        var preview = document.createElement('img');
        preview.alt = '';
        preview.src = URL.createObjectURL(file);
        preview.onload = function () { URL.revokeObjectURL(preview.src); };
        status.appendChild(preview);
      }
      if (guessed && input) {
        input.value = guessed;
        input.dispatchEvent(new Event('input', { bubbles: true }));
      }
    });
  }

  var voiceButton = overlay.querySelector('[data-voice-search]');
  var SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
  if (voiceButton && SpeechRecognition && input) {
    var recognition = new SpeechRecognition();
    recognition.lang = document.documentElement.lang || 'it-IT';
    recognition.interimResults = false;
    recognition.maxAlternatives = 1;
    recognition.addEventListener('start', function () {
      voiceButton.setAttribute('aria-pressed', 'true');
      if (status) status.textContent = strings.voiceListening || 'Sto ascoltando...';
    });
    recognition.addEventListener('end', function () {
      voiceButton.setAttribute('aria-pressed', 'false');
    });
    recognition.addEventListener('result', function (event) {
      var transcript = event.results && event.results[0] && event.results[0][0] ? event.results[0][0].transcript : '';
      if (!transcript) return;
      input.value = transcript;
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.focus();
    });
    voiceButton.addEventListener('click', function () {
      try { recognition.start(); } catch (e) {}
    });
  } else if (voiceButton) {
    voiceButton.hidden = true;
  }
})();
